import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUITranslateService,
  TUIUserService,
} from "@tencentcloud/chat-uikit-engine";
import Header from "../components/Header.vue";
import {
  ref,
  onMounted,
} from "../TUIKit/adapter-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const userProfile = ref({});
const isH5 = ref(TUIGlobal.getPlatform() === "h5");

onMounted(() => {
  //getUserProfile();
});
const getUserProfile = () => {
  TUIUserService.getUserProfile().then((res) => {
    userProfile.value = res.data;
  });
};

return { __sfc: true,userProfile, isH5, getUserProfile, TUITranslateService }
}

})